var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTechnology(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.54545 2.36364C2.89275 2.36364 2.36364 2.89275 2.36364 3.54545V15.3636C2.36364 16.0163 2.89275 16.5455 3.54545 16.5455H22.4545C23.1072 16.5455 23.6364 16.0163 23.6364 15.3636V3.54545C23.6364 2.89275 23.1072 2.36364 22.4545 2.36364H3.54545ZM0 3.54545C0 1.58735 1.58735 0 3.54545 0H22.4545C24.4126 0 26 1.58735 26 3.54545V15.3636C26 17.3217 24.4126 18.9091 22.4545 18.9091H3.54545C1.58735 18.9091 0 17.3217 0 15.3636V3.54545Z",
    fill: "#5FFFA0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.09082 22.4545C7.09082 21.8018 7.61994 21.2727 8.27264 21.2727H17.7272C18.3799 21.2727 18.909 21.8018 18.909 22.4545C18.909 23.1072 18.3799 23.6363 17.7272 23.6363H8.27264C7.61994 23.6363 7.09082 23.1072 7.09082 22.4545Z",
    fill: "#5FFFA0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0002 16.5454C13.6529 16.5454 14.182 17.0745 14.182 17.7272V22.4545C14.182 23.1072 13.6529 23.6363 13.0002 23.6363C12.3475 23.6363 11.8184 23.1072 11.8184 22.4545V17.7272C11.8184 17.0745 12.3475 16.5454 13.0002 16.5454Z",
    fill: "#5FFFA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnology);
export default __webpack_public_path__ + "static/media/technology.39a3cef23876ebe40652e22316ee2879.svg";
export { ForwardRef as ReactComponent };